import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LucideDynamicIcon, LucideIconInput } from '@lucide/angular';

export type IconSizes = 'xs' | 's' | 'sm' | 'm' | 'l' | 'xl' | 'xxl';

@Component({
  selector: 'ptl-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LucideDynamicIcon],
  // Lucide strokes with `currentColor`, so the icon follows the host `color`. Only bind an inline color when
  // one is explicitly passed; otherwise emit no inline style so `:host { color: inherit }` applies and the icon
  // takes the surrounding text color (letting parent CSS, e.g. white icons on a coloured background, override it).
  host: { '[style.color]': 'color() ?? null' },
})
export class IconComponent {
  icon = input.required<LucideIconInput>();
  size = input<IconSizes>('m');
  color = input<string>();
  strokeWidth = input<number>(1.5);

  protected readonly sizeMap: Record<IconSizes, number> = {
    xs: 16,
    s: 16,
    sm: 15,
    m: 20,
    l: 24,
    xl: 24,
    xxl: 80,
  };

  protected readonly resolvedSize = computed(() => this.sizeMap[this.size()]);
}
